import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ApService } from 'src/app/shared/services/ap.service';
import { Subscription } from 'rxjs';
import { SubMenuService } from 'src/app/shared/services/sub-menu.service';
import { TopnavbarService } from 'src/app/shared/services/topnavbar.service';
import { PageEvent } from '@angular/material/paginator';
import { UserConstant } from 'src/app/shared/constants/user-constant';
import { UserService } from 'src/app/shared/services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VhubConnectModalComponent } from '../device/vhub-connect-modal/vhub-connect-modal.component';

@Component({
  selector: 'app-vhub-device',
  templateUrl: './vhub-device.component.html',
  styleUrls: ['./vhub-device.component.scss']
})
export class VhubDeviceComponent implements OnInit, OnDestroy {
  private pageAvailable: boolean = true;
  dnetwork: any = [];
  displayedColumns: string[] = ['name', 'mac', 'email', 'domain', 'location', 'model', 'firmware', 'upTime', 'lastSeen', 'createdAt', 'Status', 'Action'];
  divicessArray: any = [];
  dataSource: any = [];

  user: any;
  domain: any;
  orgId: any;

  searchTxt = ""
  sortData: any;
  length = 0;
  pageSize = 50;
  currentPage = 1;
  pageIndex = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];

  private loadDataSubscription: Subscription;

  constructor(public dialog: MatDialog, public apService: ApService,
    private submenuService: SubMenuService,
    private router: Router, public route: ActivatedRoute,
    private topnavbarService: TopnavbarService, public userService: UserService,) {
  }

  ngOnInit() {
    let storedUser = localStorage.getItem(UserConstant.USER);
    storedUser = JSON.parse(storedUser);
    this.user = storedUser;
    this.orgId = this.userService.normalizeOrganizationId(this.user.organization);
    this.loadData();
    this.setTopNavMenu();
  }

  setTopNavMenu() {
    if (!this.pageAvailable) return;
    this.topnavbarService.set([
      {
        "route": "/layout/organization",
        "name": "Root",
        "type": "link",
      },
      {
        "route": "",
        "name": "vHub Devices",
        "type": "text",
      },
    ])
  }


  loadData(resetPage = false) {
    if (resetPage) {
      this.currentPage = 1;
      this.pageIndex = 0;
    }

    let data = {
      params: {
        id: this.orgId,
        page: this.currentPage,
        pageSize: this.pageSize,
        searchTxt: this.searchTxt,
        type: 'vhub'
      }
    };
    if (this.sortData && this.sortData.active && this.sortData.direction) {
      data.params['sortBy'] = this.sortData.active;
      data.params['sortDirection'] = this.sortData.direction;
    }

    // Cancel stale list requests when users search, sort, or page quickly.
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
    this.loadDataSubscription = this.apService.getListing(data).subscribe(res => {
      if (res) {
        this.divicessArray = res.data || [];
        this.length = Number(res.count) || 0;
        this.divicessArray.forEach(element => {
          element.upTime = this.uptimeToStr(element.statistics ? element.statistics.upTime : element.upTime);
        });
        this.dataSource = this.divicessArray;

      } else {
        this.dataSource = [];
        this.length = 0;
      }

    });
  }

  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  handleSort(sort) {
    this.sortData = sort;
    this.loadData(true);
  }

  uptimeToStr(input) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(input);
    day = Math.floor(n / (24 * 3600));
    n = Math.floor(n % (24 * 3600));
    hour = Math.floor(n / 3600);
    n = Math.floor(n % 3600);
    minutes = Math.floor(n / 60);
    n = Math.floor(n % 60);
    seconds = n;
    let str = '';
    str = str + (day ? day + 'd ' : '');
    str = str + (hour ? hour + 'h ' : '');
    str = str + (minutes ? minutes + 'm ' : '');
    str = str + (seconds ? seconds + 's' : '');
    return str;
  }

  _connectDevice(device) {
    const dialogRef = this.dialog.open(VhubConnectModalComponent, {
      disableClose: true,
      width: '700px',
      data: device
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  ngOnDestroy(): void {
    this.pageAvailable = false;
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
  }
}
